<script setup lang="ts">
useSeoMeta({
  title: 'Rückblick: Open House 2024',
  ogTitle: 'Rückblick: Open House 2024',
  description: 'Ein Rückblick auf das Open House von Mody Veranstaltungstechnik am 5. Juli 2024 in Flachau.',
  ogDescription: 'Ein Rückblick auf das Open House von Mody Veranstaltungstechnik am 5. Juli 2024 in Flachau.',
})
</script>

<template>
  <main class="bg-[#0B0B0C] text-white">
    <section class="bg-zinc-900 px-6 py-20 text-center sm:py-24">
      <p class="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-[#E39737]">Rückblick · 5. Juli 2024</p>
      <h1 class="mx-auto max-w-4xl text-4xl font-bold tracking-[-0.035em] sm:text-6xl">Open House bei Mody</h1>
      <p class="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-stone-300 sm:text-xl">
        Ein Nachmittag und Abend voller Veranstaltungstechnik, Musik und persönlicher Einblicke hinter die Kulissen unseres Standorts in Flachau.
      </p>
    </section>

    <section class="px-6 py-16 sm:py-20">
      <div class="mx-auto grid max-w-5xl gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
        <div>
          <p class="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-[#E39737]">Der Neustart 2024</p>
          <h2 class="text-3xl font-bold tracking-[-0.03em] sm:text-4xl">Danke für einen besonderen Tag</h2>
        </div>
        <div class="space-y-5 text-lg leading-relaxed text-stone-300">
          <p>
            Am 5. Juli 2024 haben wir gemeinsam den Neustart von Mody Veranstaltungstechnik gefeiert. Bei Firmenführungen konnten unsere Gäste das Lager, unser Equipment und die Arbeit hinter einer Veranstaltung kennenlernen.
          </p>
          <p>
            Der StageTruck war in Action, DJ El Gusto sorgte am Nachmittag und bei der Aftershow-Party für Musik und die Chicken Shakes spielten am Abend live.
          </p>
        </div>
      </div>
    </section>

    <section class="bg-zinc-900 px-6 py-16 sm:py-20">
      <div class="mx-auto max-w-5xl">
        <p class="mb-3 text-center text-sm font-semibold uppercase tracking-[0.18em] text-[#4C9CD4]">Das Programm</p>
        <h2 class="mb-10 text-center text-3xl font-bold tracking-[-0.03em] sm:text-4xl">Technik, Einblicke und Live-Musik</h2>
        <div class="grid gap-5 md:grid-cols-3">
          <article class="rounded-[28px] border border-white/5 bg-[#141517] p-7">
            <i class="pi pi-building mb-5 text-3xl text-[#E39737]"></i>
            <h3 class="mb-3 text-xl font-semibold">Blick hinter die Kulissen</h3>
            <p class="leading-relaxed text-stone-300">Firmenführungen und persönliche Einblicke in Equipment, Lager und Planung.</p>
          </article>
          <article class="rounded-[28px] border border-white/5 bg-[#141517] p-7">
            <i class="pi pi-volume-up mb-5 text-3xl text-[#4C9CD4]"></i>
            <h3 class="mb-3 text-xl font-semibold">StageTruck in Action</h3>
            <p class="leading-relaxed text-stone-300">Unsere mobile Bühne live aufgebaut und als Mittelpunkt des Open House.</p>
          </article>
          <article class="rounded-[28px] border border-white/5 bg-[#141517] p-7">
            <i class="pi pi-star mb-5 text-3xl text-[#E39737]"></i>
            <h3 class="mb-3 text-xl font-semibold">Musik bis am Abend</h3>
            <p class="leading-relaxed text-stone-300">DJ El Gusto, die Chicken Shakes live und eine gemeinsame Aftershow-Party.</p>
          </article>
        </div>
      </div>
    </section>

    <section class="px-6 py-16 text-center sm:py-20">
      <h2 class="text-3xl font-bold tracking-[-0.03em]">Was Mody heute macht</h2>
      <p class="mx-auto mb-8 mt-4 max-w-xl text-lg leading-relaxed text-stone-300">
        Entdecke aktuelle Projekte oder lerne das Team hinter Mody Veranstaltungstechnik kennen.
      </p>
      <div class="flex flex-col justify-center gap-3 sm:flex-row">
        <NuxtLink to="/references"><Button class="px-8">Aktuelle Referenzen</Button></NuxtLink>
        <NuxtLink to="/about"><Button severity="secondary" class="px-8">Über uns</Button></NuxtLink>
      </div>
    </section>
  </main>
</template>
